export default "__VITE_ASSET__e89c9a9b__"